import React from 'react'
import { OverlayTrigger, Popover, Glyphicon, Button } from 'react-bootstrap'

const DeliverableDocument = (props) => {
  const { deliverableDocument, deleteDocument } = props

  const size = deliverableDocument.size /1000000

  const deletePopover = (
    <Popover id="popover-basic" title="Delete Deliverable Document">
      Are you sure you want to delete this deliverable document?
      <br/><br/>
      <strong>This action is irreversible.</strong>
      <br/><br/>
      <center>
        <Button
          bsStyle="danger"
          onClick={() => deleteDocument(deliverableDocument.url)}
        >
          Delete
        </Button>
      </center>
    </Popover>
  )

  return (
    <tr>

      <td>
        <a
          href={deliverableDocument.document}
          target="_blank"
          rel="noopener noreferrer"
        >
          {deliverableDocument.name}
        </a>
      </td>

      <td>
        {`${size.toFixed(2)} MB`}
      </td>

      <td>
      <OverlayTrigger
        placement="left"
        trigger="click"
        rootClose
        overlay={deletePopover}
      >
        <Glyphicon glyph="trash" className="document-action-icon"/>
      </OverlayTrigger>
      </td>

    </tr>
  )
}

export default DeliverableDocument



// WEBPACK FOOTER //
// ./src/reuseable-components/deliverables/DeliverableDocument.js